import React from 'react';
import classNames from 'classnames';
import './tabSelectInput.module.scss';

type OptionSpec<V> = {
  label: string;
  value: V;
  metaAttributes?: object;
};

type Props<V> = {
  id?: string;
  options: OptionSpec<V>[];
  value: V | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: V) => any;
  metaAttributes?: object;
};

export function TabSelectInput<V>({ id, value, onChange, options, metaAttributes }: Props<V>) {
  return (
    <div id={id} styleName="tab-select-input" className={classNames('tab-select-input')} {...(metaAttributes || {})}>
      {options.map((option, index) => (
        <div
          key={index}
          styleName={classNames('tab-item', { active: option.value === value })}
          className={classNames('tab-item', { active: option.value === value })}
          {...(option.metaAttributes || {})}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
}
